// extracted by mini-css-extract-plugin
export default {"pageHead":"PageHead__pageHead___zaXNA","title":"PageHead__title___M3cC3","button":"PageHead__button___BpvkL"};